<template>
  <v-app>
    <!--v-main-->

    <router-view />
    <!--/v-main-->
    <!--  -->
    <v-dialog
      v-model="$store.getters.loading"
      persistent
      width="auto"
      class="pa-4"
      content-class="loader"
    >
      <div class="overflow-hidden">
        <v-row dense>
          <v-col cols="12" class="d-flex justify-center">
            <v-progress-circular
              indeterminate
              color="white"
              :size="70"
              :width="7"
            ></v-progress-circular>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <span class="white--text text-h6">
              {{ $t("Cargando por favor espere...") }}
            </span>
          </v-col>
        </v-row>
      </div>
    </v-dialog>

    <template v-if="$store.getters.message != null">
      <v-dialog v-model="$store.getters.message" persistent max-width="400">
        <v-card class="pa-5 overflow-hidden">
          <v-card-text class="text-center">
            {{ $store.getters.message }}
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn
              outlined
              block
              color="green"
              @click="$store.commit('setMessage', null)"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <template v-if="$store.getters.error">
      <v-dialog
        v-model="$store.getters.error"
        persistent
        max-width="981"
        width="auto"
      >
        <v-card class="pa-5 overflow-hidden">
          <v-card-text class="text-center">
            <div class="d-block">
              <v-icon
                class="red lighten-5 red--text text--darken-1 pa-3 mb-3 rounded-pill"
                size="40"
                >mdi-alert-circle</v-icon
              >
            </div>
            <span class="red--text">{{ $store.getters.error }}</span>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn
              color="red"
              @click="cerrarError"
              outlined
              block
              >Aceptar</v-btn
            >
          </v-card-actions>
          <!-- La caja de este equipo está instalada en otro (POS.EQUIPO.*): o la liberan en el ERP,
               o este equipo pasa a otra caja. -->
          <v-card-actions
            v-if="$store.getters.equipo_rechazado"
            class="d-flex justify-center"
          >
            <v-btn
              id="btn-instalar-otra-caja"
              color="primary"
              text
              block
              @click="desinstalarCajaLocal"
              >Instalar otra caja en este equipo</v-btn
            >
          </v-card-actions>
          <!-- Sólo en un entorno local: si este equipo quedó con la caja de otra base (una copia
               restaurada, otra empresa) no hay forma de salir del aviso desde la interfaz. En
               producción este botón no existe: allí la caja se cambia en la configuración. -->
          <v-card-actions
            v-if="puedeDesinstalarCajaLocal"
            class="d-flex justify-center"
          >
            <v-btn
              id="btn-desinstalar-caja-local"
              color="grey darken-2"
              text
              block
              @click="desinstalarCajaLocal"
              >Desinstalar la caja de este equipo (sólo local)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <iframe id="printf" name="printf" style="width: 1px; height: 1px"></iframe>

    <!--v-dialog v-model="nubeempresaIsOpen" persistent width="300">
      <v-card class="pa-3">
        <v-card-text style="color: red">
          Este sitio ya está abierto en otra pestaña o ventana. Por razones de
          seguridad y consistencia  solo puedes abrir una
          ventana para el POS. Este mensaje se ocultará cuando cierres las otras
          ventanas, en caso de no se cierre, puedes recargar el navegador.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="red" @click="windowClose">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog-->

  </v-app>
</template>

<style lang="scss">
.v-btn--is-elevated {
  box-shadow: none !important;
}

.loader {
  box-shadow: none !important;
}
</style>
<script>
import localAgent from "@/plugins/local-agent.js";
import appUtil from "@/plugins/app-utils.js";
import { desinstalarCajaDeEsteEquipo } from "@/plugins/pos-equipo.js";

export default {
  name: "App",
  data: () => ({
    ws: null,
    document: null,
  }),
  async mounted() {
    /*let auth = localStorage.getItem("auth");
    if (auth) {
      auth = JSON.parse(auth);
      this.$store.commit("setAuth", auth);
      this.$currentUser.setData(auth);
      // console.log(this.$currentUser)
      // this.$store.dispatch('autoSignIn', auth)
    }*/
    /*let cities = await getCities();
    console.log(cities);*/

    /* setTimeout(() => {
      listenEvents(222, (doc)=> {
        console.log(doc)
        this.document = doc;
      })
    }, 1000);*/

    if (appUtil.isAppPos()) {
      this.validateAgent();
      setInterval(() => {
        this.validateAgent();
      }, 1 * 60 * 1000);
    }

    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  computed: {
    // El backend responde BILLING.CASH_TURN.CASH_REGISTER_NOT_FOUND / SUBSIDIARY_NOT_FOUND, pero a
    // esta modal sólo le llega el texto; se reconoce por cómo empieza.
    puedeDesinstalarCajaLocal() {
      const api = process.env.VUE_APP_BASECONFIG_URL || "";
      const esLocal = /\/\/(localhost|127\.0\.0\.1)(:|\/)/.test(api);
      const error = String(this.$store.getters.error || "");
      return (
        esLocal &&
        (error.startsWith("La caja de este equipo") ||
          error.startsWith("La sucursal de este equipo"))
      );
    },
  },
  methods: {
    cerrarError() {
      this.$store.commit("setEquipoRechazado", false);
      this.$store.dispatch("clearError");
    },
    async desinstalarCajaLocal() {
      await desinstalarCajaDeEsteEquipo(this.$db, this.$store);
      window.location.reload();
    },
    async validateAgent() {
      try {
        let useAgent = false;
        let installation = this.$store.getters.installation;
        if (installation) {
          const cashRegister = await this.$db.getCashRegister(
            installation.cash_id
          );
          if (cashRegister) {
            if (cashRegister.config) {
              if (cashRegister.config.pos_active_print_agent) {
                console.log("use agent");
                useAgent = true;
              }
            }
          }
        }
        if (useAgent) {
          // Realizar una solicitud GET a la API en localhost:5777/is-run
          const response = await localAgent.validateAgent();
          // Comprobar el código de estado de la respuesta (200 significa éxito)
          if (response.success == true) {
            console.log("Agent ok....");
            this.$store.commit("setAgent", true);
            //this.connectWebSocket();
          } else {
            console.log("Agent error....");
            this.$store.commit("setAgent", false);
          }
        }
      } catch (e) {
        console.log("Agent error....");
        this.$store.commit("setAgent", false);
      }
    },
    closeTab() {
      window.close();
    },
    onResize() {
      const screen = window.screen;
      const mobile = window.innerWidth < 960;

      const aspect_ratio = {
        screen_width: screen.width,
        screen_height: screen.height,
        aspect_ratio: this.calculateAspectRatio(screen.width, screen.height),
      };
      //console.log(aspect_ratio);
      this.$store.commit("setMobile", mobile);
      this.$store.commit("setAspectRatio", aspect_ratio);
    },
    nearestNormalAspectRatio(width, height, side) {
      let ratio = (width * 100) / (height * 100),
        maxW = 3 in arguments ? arguments[2] : 16,
        maxH = 4 in arguments ? arguments[3] : 16,
        ratiosW = new Array(maxW).join(",").split(","),
        ratiosH = new Array(maxH).join(",").split(","),
        ratiosT = {},
        ratios = {},
        match,
        key;

      ratiosW.forEach(function (empty, ratioW) {
        ++ratioW;

        ratiosH.forEach(function (empty, ratioH) {
          ++ratioH;

          let ratioX = (ratioW * 100) / (ratioH * 100);

          if (!ratiosT[ratioX]) {
            ratiosT[ratioX] = true;

            ratios[ratioW + ":" + ratioH] = ratioX;
          }
        });
      });

      for (key in ratios) {
        if (
          !match ||
          (!side &&
            Math.abs(ratio - ratios[key]) < Math.abs(ratio - ratios[match])) ||
          (side < 0 &&
            ratios[key] <= ratio &&
            Math.abs(ratio - ratios[key]) < Math.abs(ratio - ratios[match])) ||
          (side > 0 &&
            ratios[key] >= ratio &&
            Math.abs(ratio - ratios[key]) < Math.abs(ratio - ratios[match]))
        ) {
          match = key;
        }
      }
      if (match == "8:5") {
        match = "16:10";
      }
      if (match == "8:3") {
        match = "16:9";
      }
      return match;
    },
    calculateAspectRatio(width, height) {
      return this.nearestNormalAspectRatio(width, height);
    },
  },
};
</script>
<style>
.form-default {
  width: 860px;
}
.support-chat {
  position: fixed;
  z-index: 1;
  right: -0.5vw;
  bottom: 4vw;
  margin: 8px;
}

@media (max-width: 768px) {
  .support-chat {
    position: fixed;
    z-index: 1;
    right: -1.5vw;
    bottom: 5vh;
    margin: 8px;
  }
}

.support-chat .v-badge__badge {
  background: white;
  outline: 2px solid var(--v-primary-lighten1);
  color: var(--v-secondary-lighten1);
}

/* Listados del POS (órdenes, egresos, notas, tarjetas, turnos): tabla más limpia y legible. */
.listing-app.v-data-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.listing-app.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background: #eaf1f7;
  color: var(--pos-azul-marino) !important;
  font-size: 12px !important;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}
.listing-app.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
  background: rgba(36, 169, 225, 0.1) !important;
}
.listing-app.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.listing-app.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0 8px !important;
}
.listing-app.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13.5px;
}
/* La columna de acciones queda siempre a la vista aunque la tabla se desplace a un lado. */
.listing-app.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child,
.listing-app.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  position: sticky;
  right: 0;
  z-index: 1;
  background: #fff;
  box-shadow: -6px 0 6px -6px rgba(0, 0, 0, 0.18);
}
.listing-app.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
  background: #eaf1f7;
}
.listing-app.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover > td:last-child {
  background: #e9f6fc;
}
.listing-app .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 13px;
}
.list-mobile .v-list-item {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Colores del POS en un solo lugar. Salen de la pantalla de login (azul marino de fondo, azul de marca #24a9e1 del logo, verde de acento).
   Antes de ajustar los colores (3 nov 2026) el encabezado de las modales era linear-gradient(120deg, #0b5ea8, #24a9e1) y el azul oscuro #0b5ea8:
   para volver, pon esos valores en --pos-encabezado y --pos-azul-oscuro. */
:root {
  --pos-azul-marino: #0d2d4a;
  --pos-azul-oscuro: #0e4f7e;
  --pos-azul: #24a9e1;
  --pos-verde: #2e7d32;
  --pos-encabezado: linear-gradient(120deg, #0d2d4a 0%, #0e4f7e 55%, #24a9e1 100%);
}

/* Pantalla de venta: fondo del login (#f7f7f9) en el panel de productos. */
#search_prd,
#search_prd .grey.lighten-4 {
  background-color: #f7f7f9 !important;
}

/* Barras del POS en celular (total y volver a productos): el degradado del login. */
.v-toolbar.barra-pos {
  background: var(--pos-encabezado) !important;
}

/* Ventana de pago: la barra de saldo con el degradado del login y «Pago completo» en el verde de acento. */
.v-alert.alerta-pos {
  background: var(--pos-encabezado) !important;
  border-color: transparent !important;
}
.v-btn.boton-pago-completo:not(.v-btn--disabled) {
  background-color: var(--pos-verde) !important;
}
.v-btn.boton-pago-completo:not(.v-btn--disabled):hover {
  background-color: #256628 !important;
}

/* Modales del POS: el encabezado azul de «Activar tarjeta» en todas (las que ya traen barra con color primario y las que usan EncabezadoModal). */
.v-dialog > .v-card,
.v-dialog > form > .v-card,
.v-dialog > div > .v-card {
  border-radius: 12px;
}
.v-dialog .v-toolbar.primary,
.v-dialog .v-app-bar.primary,
.v-dialog .v-card__title.primary {
  background: var(--pos-encabezado) !important;
  border-color: transparent !important;
  color: #fff;
}
.v-dialog .v-toolbar.primary .v-toolbar__title,
.v-dialog .v-app-bar.primary .v-toolbar__title {
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
}
.v-dialog .v-toolbar.primary,
.v-dialog .v-app-bar.primary {
  height: auto !important;
}
.v-dialog .v-toolbar.primary .v-toolbar__content,
.v-dialog .v-app-bar.primary .v-toolbar__content {
  height: 60px !important;
  padding: 4px 20px;
}
.encabezado-modal {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: var(--pos-encabezado);
  color: #fff;
}
.encabezado-modal__titulo {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.encabezado-modal__titulo strong {
  font-size: 18px;
  font-weight: 600;
}
.encabezado-modal__titulo small {
  opacity: 0.9;
}
</style>
